import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Typography,
  IconButton,
  Button,
  TextField,
  Switch,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Checkbox
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import SecurityIcon from '@mui/icons-material/Security';
import TuneIcon from '@mui/icons-material/Tune';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LinkIcon from '@mui/icons-material/Link';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import LaptopMacIcon from '@mui/icons-material/LaptopMac';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AxiosInstance from "../../services/AxiosInstance";
import {
  getUserEmail,
  getUserName,
  getUserProfileImage
} from "../../services/cacheService";
import { useAlert } from "./../alerts/AlertContext";

import { USERS_URL, USER_ADDRESS_BY_USER_ID_URL, USER_ROLES_BY_USER_URL, USER_CHANGE_PASSWORD, USER_PROFILE_PICTURE, USER_LOAD_PROFILE_PICTURE, USER_DELETE_PROFILE_PICTURE, RESOLVER_GROUPS_USER_URL, ESCALATION_USER_ESCALATION_ROLES_URL } from "../../Constants/Constants";
import { USER_ID, JWT_TOKEN } from "../../Constants/StorageConstants";


const menuItems = [
  {
    label: 'Personal Information',
    icon: <PersonIcon />,
    content: 'Update your name, email, and contact details.'
  },
  {
    label: 'Account Settings',
    icon: <SettingsIcon />,
    //content: 'Manage your username, password, and login methods.'
  },
  {
    label: 'Security',
    icon: <SecurityIcon />,
    //content: 'Configure 2FA, active sessions, and login alerts.'
  },
  {
    label: 'Preferences',
    icon: <TuneIcon />,
    content: 'Adjust your theme, language, and notification preferences.'
  },
  {
    label: 'Access & Roles',
    icon: <AdminPanelSettingsIcon />,
    //content: 'View and request roles, manage permissions and responsibilities.'
  },
  {
    label: 'Linked Accounts',
    icon: <LinkIcon />,
    //content: 'Connect or disconnect external services or identity providers.'
  },
  {
    label: 'Delegation',
    icon: <GroupAddIcon />,
    //content: 'Assign or receive delegated access to your account.'
  }
];

const ProfileSettingsDialog = ({ open, onClose }) => {
  const [selected, setSelected] = useState(menuItems[0]);
  const [profileImage, setProfileImage] = useState(null);
  const [selectedDelegate, setSelectedDelegate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [notifyBoth, setNotifyBoth] = useState(true);
  const [comments, setComments] = useState('');

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const userName = getUserName();
  const userEmail = getUserEmail();
  const [data, setData] = useState();
  const [address, setAddress] = useState();
  const [userRoles, setUserRoles] = useState();
  const [userGroups, setUserGroups] = useState();
  const [escalationRoles, setEscalationRoles] = useState();

  const showAlert = useAlert();
  //const profileImage = getUserProfileImage();
  //setProfileImage(getUserProfileImage());

  useEffect(() => {
    if (open) {
      getUser(localStorage.getItem(USER_ID));
      getUserAddress(localStorage.getItem(USER_ID));
      getUserRoles(localStorage.getItem(USER_ID));
      loadProfileImage(localStorage.getItem(USER_ID));
      getResolverGroups(localStorage.getItem(USER_ID));
      getEscalationRoles(localStorage.getItem(USER_ID));
    }
  }, [open]);

  const [delegationNotes, setDelegationNotes] = useState([
    'John Smith approved ticket #1234 on your behalf.',
    'Jane Doe escalated issue #998 during delegation.',
    'Mark Jones resolved incident #4423 for you.',
  ]);

  const getUser = (userId) => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(`${USERS_URL}/${userId}`).then((response) => setData(response.data.data));
  };

  const getUserRoles = (userId) => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(USER_ROLES_BY_USER_URL + userId).then((response) => setUserRoles(response.data));
  };

  const getResolverGroups = (userId) => {
    AxiosInstance.get(`${RESOLVER_GROUPS_USER_URL}/${userId}`).then(response => setUserGroups(response.data));
  }

  const getEscalationRoles = (userId) => {
    AxiosInstance.get(`${ESCALATION_USER_ESCALATION_ROLES_URL}/${userId}`).then(response => setEscalationRoles(response.data));
  }

  const getUserAddress = (userId) => {
    AxiosInstance.get(`${USER_ADDRESS_BY_USER_ID_URL}/${userId}`).then(response => {
      setAddress(response.data);
    }).catch(error => {
      if (error.response) {
        if (error.response.status === 404) {
          console.error('Resource not found (404)');
          //setAddress("");
        } else {
          console.error('Server responded with error:', error.response.status);
        }
      } else if (error.request) {
        console.error('No response from server');
      } else {
        console.error('Axios error:', error.message);
      }
    });
  }

  const handleDelegationSubmit = () => {
    console.log({
      selectedDelegate,
      startDate,
      endDate,
      notifyBoth,
      comments
    });
    // Submit to API here
  };

  const changePassword = () => {

    var user = {};
    user.userId = localStorage.getItem(USER_ID);
    user.newPassword = newPassword;
    user.currentPassword = currentPassword;

    AxiosInstance.put(USER_CHANGE_PASSWORD, user)
      .then((response) => {
        showAlert(response.data.message, response.data.success === true ? "success" : "error");

      })
      .catch((error) => {
        showAlert("User updation failed!", "error");
        console.error(error);
      });
  }


  const handleCurrentPasswordChange = (event) => {
    setCurrentPassword(event.target.value);
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleChangePassword = (event) => {

    if (newPassword !== confirmPassword) {
      showAlert("New pasword and confirm password not matched!", "error");
    } else {
      changePassword();
    }
  }

  const uploadProfilePicture = (e) => {
    let formData = new FormData();
    const file = e.target.files[0];
    formData.append("file", file);
    formData.append("userId", localStorage.getItem(USER_ID));
    formData.append("userName", userName);

    AxiosInstance.put(USER_PROFILE_PICTURE, formData, {
      ...(AxiosInstance.defaults.headers["Content-Type"] =
        "multipart/form-data"),
    })
      .then((response) => {
        //alert("Mail Sent successfully");
        if (response.status === 200) {
          showAlert(response.data.data, "Profile pic uploaded successfully!!", "success");
          setProfileImage(URL.createObjectURL(file));
        }

        else
          showAlert(response.data.data, "error");
      })
      .catch((error) => {
        showAlert("Upload profile picture failed!", "error");
        console.error(error);
      });

  }

  const loadProfileImage = (userId) => {
    AxiosInstance.get(`${USER_LOAD_PROFILE_PICTURE}/${userId}/pic`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}` }
    }).then(res => {
      if (res.status !== 401 && res.status !== 500) {
        const imgUrl = URL.createObjectURL(res.data);
        setProfileImage(imgUrl);
      }

    }).catch(error => {
      if (error.response) {
        if (error.response.status === 404) {
          console.error('Resource not found (404)');
          //setAddress("");
        } else {
          console.error('Server responded with error:', error.response.status);
        }
      } else if (error.request) {
        console.error('No response from server');
      } else {
        console.error('Axios error:', error.message);
      }
    });;

  }

  const removeProfilePicture = (e) => {
    AxiosInstance.get(`${USERS_URL}/${localStorage.getItem(USER_ID)}/pic`, {
      headers: { Authorization: `Bearer ${localStorage.getItem(JWT_TOKEN)}` }
    }).then(res => {
      if (res.status === 200) {
        setProfileImage(null);
      } else {
        showAlert(res.data, "error");
      }

    });

  }

  return (
    <ThemeProvider>
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          Profile Settings
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{ display: 'flex', height: '70vh', overflow: 'hidden', p: 0 }}
        >
          {/* Left Menu */}
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              height: '100%',
              overflow: 'hidden',
            }}
          >
            {/* Sidebar */}
            <Box
              sx={{

                backgroundColor: '#f9f9f9',
                borderRight: '1px solid #ddd',
                p: 2,
                flexShrink: 0,
              }}
            >
              <List>
                {menuItems.map((item) => (
                  <ListItemButton
                    key={item.label}
                    selected={selected.label === item.label}
                    onClick={() => setSelected(item)}
                  >
                    <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                ))}
              </List>
            </Box>

            {/* Right Content */}
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                overflowY: 'auto',
                height: '69vh',
                width: '100%'
              }}
            >
              <Typography variant="h6">{selected.label}</Typography>
              <Divider sx={{ my: 1 }} />
              <Typography variant="body1">{selected.content}</Typography>

              {selected.label === 'Personal Information' ? (
                <Box sx={{ mt: 2 }}>
                  {/* Profile Picture Section */}

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ position: 'relative', width: 100, height: 100 }}>
                      <Box
                        component="img"
                        src={profileImage || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI0NDQyIgdmlld0JveD0iMCAwIDUwIDUwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxjaXJjbGUgY3g9IjI1IiBjeT0iMTUiIHI9IjEwIiBmaWxsPSIjZmZmIi8+PHJlY3QgeT0iMzAiIHg9IjEwIiB3aWR0aD0iMzAiIGhlaWdodD0iMTUiIHJ4PSIzIiBmaWxsPSIjZmZmIi8+PC9zdmc+'
                        }
                        alt="Profile"
                        sx={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '50%',
                          objectFit: 'cover',
                          border: '1px solid #ccc'
                        }}
                      />

                      {/* Hidden File Input */}
                      <input
                        id="profile-upload"
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setProfileImage(URL.createObjectURL(file));
                          }
                        }}
                      />

                      {/* Camera Icon Overlay */}
                      <label htmlFor="profile-upload">
                        <IconButton
                          sx={{
                            position: 'absolute',
                            bottom: 0,
                            right: 0,
                            backgroundColor: '#fff',
                            borderRadius: '50%',
                            boxShadow: 1,
                            padding: '4px',
                            '&:hover': { backgroundColor: '#f0f0f0' }
                          }}
                          component="span"
                        >
                          <CameraAltIcon fontSize="small" />
                        </IconButton>
                      </label>
                    </Box>

                    {/* Upload / Remove Buttons */}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Button
                        variant="outlined"
                        component="label"
                        size="small"
                      >
                        Upload Image
                        <input
                          hidden
                          accept="image/*"
                          type="file"
                          onChange={uploadProfilePicture}
                        />
                      </Button>

                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={removeProfilePicture}
                      >
                        Remove Image
                      </Button>
                    </Box>
                  </Box>

                  {/* Form Fields */}
                  <Box sx={{ mt: 3, display: 'grid', gap: 2, gridTemplateColumns: '1fr 1fr' }}>
                    <TextField label="Full Name" value={userName} fullWidth slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }} />
                    <TextField label="Designation / Role" fullWidth value={data?.organizationTitle?.name} slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }} />
                    <TextField label="Department" value={data?.department?.name} fullWidth slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }} />
                    <TextField
                      label="Organization"
                      value={data?.organization?.name || ''}
                      fullWidth
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                    />

                    <TextField label="Contact Number" value={data?.phone || ''} fullWidth slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }} />
                    <TextField label="Email" value={data?.email} fullWidth />
                    <TextField
                      label="Time Zone"
                      fullWidth
                      value={Intl.DateTimeFormat().resolvedOptions().timeZone}
                      disabled
                    />
                  </Box>
                </Box>
              ) : (
                <Typography variant="body1" sx={{ mt: 2 }}>
                  {selected.content}
                </Typography>
              )}

              {selected.label === 'Security' ? (
                <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>

                  {/* Change Password */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>Change Password</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 400 }}>
                      <TextField type="password" label="Current Password" fullWidth onChange={handleCurrentPasswordChange} />
                      <TextField type="password" label="New Password" fullWidth onChange={handleNewPasswordChange} />
                      <TextField type="password" label="Confirm New Password" fullWidth onChange={handleConfirmPasswordChange} />
                      <Button variant="contained" color="primary" onClick={handleChangePassword}>Update Password</Button>
                    </Box>
                  </Box>

                  {/* Multi-Factor Authentication */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>Multi-Factor Authentication (MFA)</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Typography variant="body2">
                        Add an extra layer of security to your account.
                      </Typography>
                      <Switch checked={true} color="primary" />
                    </Box>
                  </Box>

                  {/* Active Sessions */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>Active Sessions</Typography>
                    <Typography variant="body2" gutterBottom>
                      These are the devices where you're currently signed in.
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      {[
                        { device: 'Chrome on Windows', ip: '192.168.1.10', lastActive: '2 mins ago' },
                        { device: 'Safari on iPhone', ip: '192.168.1.20', lastActive: '1 hour ago' }
                      ].map((session, index) => (
                        <Box
                          key={index}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            border: '1px solid #ccc',
                            borderRadius: 1,
                            p: 2,
                            maxWidth: 600
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <LaptopMacIcon color="action" />
                            <Box>
                              <Typography variant="body1">{session.device}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                IP: {session.ip} — Last active: {session.lastActive}
                              </Typography>
                            </Box>
                          </Box>
                          <Button size="small" variant="outlined" color="error">Sign Out</Button>
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  {/* Login History */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>Login History</Typography>
                    <Box sx={{ overflowX: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '0.5rem' }}>
                        <thead>
                          <tr style={{ background: '#f0f0f0' }}>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Date</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>IP Address</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Device</th>
                            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>2025-07-18 14:23</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>192.168.1.10</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>Chrome on Windows</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>Success</td>
                          </tr>
                          <tr>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>2025-07-17 20:02</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>192.168.1.22</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>Safari on iPhone</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>Failed</td>
                          </tr>
                        </tbody>
                      </table>
                    </Box>
                  </Box>
                </Box>
              ) : (
                <Typography variant="body1" sx={{ mt: 2 }}>
                  {selected.content}
                </Typography>
              )}

              {selected.label === 'Account Settings' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 600 }}>

                  {/* Username */}
                  <TextField
                    label="Username"
                    value={data?.id}
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />

                  {/* Registered Email */}
                  <TextField
                    label="Registered Email"
                    value={data?.email}
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />

                  {/* Preferred Language */}
                  <FormControl fullWidth>
                    <InputLabel id="language-label">Preferred Language</InputLabel>
                    <Select
                      labelId="language-label"
                      label="Preferred Language"
                      value="en"
                      onChange={(e) => console.log('Language changed:', e.target.value)}
                    >
                      <MenuItem value="en">English</MenuItem>
                      <MenuItem value="fr">French</MenuItem>
                      <MenuItem value="es">Spanish</MenuItem>
                      <MenuItem value="de">German</MenuItem>
                    </Select>
                  </FormControl>

                  {/* Email Notifications */}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={true}
                        onChange={(e) => console.log('Email notifications:', e.target.checked)}
                      />
                    }
                    label="Email Notifications"
                  />

                  {/* In-App Notifications */}
                  <FormControlLabel
                    control={
                      <Switch
                        checked={false}
                        onChange={(e) => console.log('In-app notifications:', e.target.checked)}
                      />
                    }
                    label="In-App Notifications"
                  />
                </Box>
              )}


              {selected.label === 'Access & Roles' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

                  {/* Assigned Roles */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>Assigned Roles</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {userRoles != null && userRoles.map((role, idx) => (
                        <Chip key={idx} label={role?.role?.name} color="primary" variant="outlined" />
                      ))}
                    </Box>
                  </Box>

                  {/* Group Memberships */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>Group Memberships</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {userGroups != null && userGroups.map((group, idx) => (
                        <Chip key={idx} label={group.groupName} color="secondary" variant="outlined" />
                      ))}
                    </Box>
                  </Box>

                  {/* Escalation Roles */}
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>Escalation Roles</Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      {!escalationRoles.levelOneMatched &&
                        !escalationRoles.levelTwoMatched && (
                          <Chip label="No Roles" color="default" variant="outlined" />
                        )}

                      {escalationRoles.levelOneMatched && (
                        <Chip label="Level One" color="success" variant="outlined" />
                      )}

                      {escalationRoles.levelTwoMatched && (
                        <Chip label="Level Two" color="success" variant="outlined" />
                      )}


                    </Box>
                  </Box>
                </Box>
              )}

              {selected.label === 'Linked Accounts' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 600 }}>

                  {/* Google Account */}
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="Google" width={24} />
                      <Typography>Google</Typography>
                    </Box>
                    <Button variant="outlined" color="error" onClick={() => console.log('Unlink Google')}>
                      Unlink
                    </Button>
                  </Box>

                  {/* GitHub Account */}
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <img src="https://www.svgrepo.com/show/512317/github-142.svg" alt="GitHub" width={24} />
                      <Typography>GitHub</Typography>
                    </Box>
                    <Button variant="outlined" color="primary" onClick={() => console.log('Link GitHub')}>
                      Link
                    </Button>
                  </Box>

                  {/* Azure AD Account */}
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <img src="https://www.svgrepo.com/show/448221/azure.svg" alt="Azure" width={24} />
                      <Typography>Azure AD</Typography>
                    </Box>
                    <Button variant="outlined" color="primary" onClick={() => console.log('Link Azure')}>
                      Link
                    </Button>
                  </Box>
                </Box>
              )}

              {selected.label === 'Delegation' && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 600 }}>

                  {/* Select Delegate */}
                  <FormControl fullWidth>
                    <InputLabel id="delegate-label">Select Delegate</InputLabel>
                    <Select
                      labelId="delegate-label"
                      label="Select Delegate"
                      value={selectedDelegate}
                      onChange={(e) => setSelectedDelegate(e.target.value)}
                    >
                      <MenuItem value="john.smith">John Smith</MenuItem>
                      <MenuItem value="jane.doe">Jane Doe</MenuItem>
                      <MenuItem value="mark.jones">Mark Jones</MenuItem>
                    </Select>
                  </FormControl>

                  {/* Start Date */}
                  <TextField
                    label="Delegation Start Date"
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />

                  {/* End Date */}
                  <TextField
                    label="Delegation End Date"
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />

                  {/* Notify Checkbox */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={notifyBoth}
                        onChange={(e) => setNotifyBoth(e.target.checked)}
                      />
                    }
                    label="Notify both delegator and delegatee"
                  />

                  {/* Comments */}
                  <Box>
                    <Typography variant="h6" gutterBottom>
                      Delegation Activity Summary
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      {delegationNotes.map((note, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <NotificationsActiveIcon fontSize="small" color="primary" />
                          <Typography variant="body2">{note}</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>

                  {/* Submit Button */}
                  <Button
                    variant="contained"
                    onClick={() => handleDelegationSubmit()}
                    sx={{ alignSelf: 'flex-start' }}
                  >
                    Setup Delegation
                  </Button>
                </Box>
              )}


            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </ThemeProvider>
  );
};

export default ProfileSettingsDialog;
